import React from 'react';

function formatDay(ts) {
  if (!ts) return '';
  const d = new Date(ts);
  if (Number.isNaN(d.getTime())) return String(ts).slice(0, 10);
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
}

export default function TroupeBriefCards({ cards }) {
  const list = Array.isArray(cards) ? cards.filter((c) => c && c.excerpt) : [];
  if (!list.length) return null;
  return (
    <div className="troupe-brief-cards">
      {list.map((c, i) => (
        <article key={c.url || `${c.character}-${i}`} className="troupe-brief-card">
          <header className="troupe-brief-card-meta">
            <span className="troupe-brief-card-who">{c.character}</span>
            {c.kind === 'featured' && <span className="troupe-brief-card-tag">worth opening</span>}
            <span className="troupe-brief-card-day">{formatDay(c.timestamp)}</span>
          </header>
          <p className="troupe-brief-card-excerpt">{c.excerpt}</p>
          {c.url && (
            <a
              className="troupe-brief-card-open"
              href={c.url}
              target="_blank"
              rel="noopener noreferrer"
            >
              Open on Bluesky
            </a>
          )}
        </article>
      ))}
    </div>
  );
}
